import { makeActionFactory } from './actionFactory';
import { Credentials, InstantMessageMap, InstantMessageId } from 'types';
import { LoginResponse } from 'api';

export type ActionType =
    'SET_LANGUAGE_REQUEST'
    | 'SET_LANGUAGE_SUCCESS'
    | 'LOGIN_REQUEST'
    | 'LOGIN_FAILURE'
    | 'LOGIN_SUCCESS'
    | 'LOGOUT'
    | 'SET_TOP_BAR_VISIBILITY'
    | 'INSTANT_MESSAGES_RECEIVED'
    | 'INSTANT_MESSAGE_DISMISSED'
;

const actionFactory = makeActionFactory<ActionType>();


export interface SetLanguageRequestAction {
    type: 'SET_LANGUAGE_REQUEST';
    payload: string;
}
export const setLanguageRequest = actionFactory.payload<SetLanguageRequestAction, string>('SET_LANGUAGE_REQUEST');


export interface SetLanguageSuccessAction {
    type: 'SET_LANGUAGE_SUCCESS';
    payload: string;
}
export const setLanguageSuccess = actionFactory.payload<SetLanguageSuccessAction, string>('SET_LANGUAGE_SUCCESS');


export interface LoginRequestAction {
    type: 'LOGIN_REQUEST';
    payload: Credentials;
}
export const loginRequest = actionFactory.payload<LoginRequestAction, Credentials>('LOGIN_REQUEST');


export interface LoginSuccessAction {
    type: 'LOGIN_SUCCESS';
    payload: LoginResponse;
}
export const loginSuccess = actionFactory.payload<LoginSuccessAction, LoginResponse>('LOGIN_SUCCESS');


export interface LoginFailureAction {
    type: 'LOGIN_FAILURE';
    payload: Error;
    error: boolean;
}
export const loginFailure = actionFactory.error<LoginFailureAction>('LOGIN_FAILURE');


export interface LogoutAction {
    type: 'LOGOUT';
}
export const logout = actionFactory.empty<LogoutAction>('LOGOUT');


export interface SetTopBarVisibilityAction {
    type: 'SET_TOP_BAR_VISIBILITY';
    payload: boolean;
}
export const setTopBarVisibility = actionFactory.payload<SetTopBarVisibilityAction, boolean>('SET_TOP_BAR_VISIBILITY');


export interface InstantMessagesReceivedAction {
    type: 'INSTANT_MESSAGES_RECEIVED';
    payload: InstantMessageMap;
}
export const instantMessagesReceived = actionFactory.payload<InstantMessagesReceivedAction, InstantMessageMap>('INSTANT_MESSAGES_RECEIVED');


export interface InstantMessageDismissedAction {
    type: 'INSTANT_MESSAGE_DISMISSED';
    payload: InstantMessageId | null; // null to dismiss all
}
export const instantMessageDismissed = actionFactory.payload<InstantMessageDismissedAction, InstantMessageId | null>('INSTANT_MESSAGE_DISMISSED');



// WEBPACK FOOTER //
// ./src/actions/shellActions.ts